<template>
  <div
    class="col-3"
    v-if="objects"
    v-loading="loading"
  >
    <div class="b-map-sidebar">
      <div class="b-map-sidebar-container">
        <div>
          <div class="row b-map-sidebar-label">
            <div class="col-4">Объект</div>
            <div
              class="col-8"
              style="text-align: right; cursor: pointer;"
              @click="selectAllObjects"
            >
              Выбрать все объекты
            </div>
          </div>
          <el-select
            class="b-single-select"
            v-model="selectedObjects"
            placeholder="Выберите объект"
            multiple
            @change="selectObject"
          >
            <el-option
              v-for="(item, index) in objects"
              :key="index"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
        <div>
          <div class="b-map-sidebar-label">
            {{ isSecondDateRequired ? 'Выберите период' : 'Выберите месяц и год' }}
          </div>
          <div class="row b-datepicker-container">
            <div class="col-6">
              <el-date-picker
                v-model="selectedDateFrom"
                type="month"
                format="MM-YYYY"
                value-format="YYYY-MM"
              />
            </div>
            <div class="col-6">
              <el-date-picker
                v-model="selectedDateTo"
                v-if="isSecondDateRequired"
                type="month"
                format="MM-YYYY"
                value-format="YYYY-MM"
              />
            </div>
          </div>
        </div>
        <div>
          <div class="b-map-sidebar-label">
            Список запросов
          </div>
          <el-select
            class="b-single-select"
            v-model="selectedIndicator"
            multiple
          >
            <el-option
              v-for="item in indicators"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
      </div>
      <div class="b-map-sidebar-container">
        <div>
          <el-button
            class="mb-2 b-button"
            type="button"
            v-loading.fullscreen.lock="loading"
            @click="createReport"
          >
            Сформировать запрос
          </el-button>
          <el-button
            class="mb-2 b-button"
            type="info"
            @click="drop"
          >
            Сбросить все параметры
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment/moment";

export default {
  name: "ReportSideBar",
  props: {
    field: {
      type: String,
      required: true,
    },
    reportData: {
      type: Object,
      required: true,
    },
    selectedReport: {
      type: String,
      required: true,
    },
    places: {
      type: Array,
      required: true,
    },
    reports: {
      type: Object,
      required: true,
    },
    objects: {
      type: Array,
      required: true,
    },
    indicators: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      allField: 'Всё месторождение',
      selectedObjects: [],
      selectedIndicator: [],
      selectedDateFrom: moment().format('YYYY-MM'),
      selectedDateTo: moment().format('YYYY-MM'),
    }
  },
  computed: {
    isSecondDateRequired() {
      let res = false;
      Object.entries(this.reports).filter(([key, value]) => {
        return value.is_second_date_required;
      }).forEach(item => {
        if (item[0] === this.selectedReport) {
          res = true;
        }
      });
      return res;
    },
  },
  methods: {
    selectAllObjects() {
      this.selectedObjects = this.objects.filter(item => item !== this.allField);
    },
    createReport() {
      this.loading = true;
      const data = {
        report: this.selectedReport,
        objects: this.selectedObjects,
        indicators: this.selectedIndicator,
        date_from: this.selectedDateFrom,
        date_to: this.isSecondDateRequired ? this.selectedDateTo : null,
      }
      axios.post(route('reports.create', this.field), data)
        .then(response => {
          this.$emit('reportCreated', [response.data, data]);
          this.$notify.success({
            title: 'Отчет сформирован',
          });
        }).catch(error => {
        this.$notify.error({
          title: 'Ошибка',
          message: error.response.data.message,
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    drop() {
      this.selectedObjects = [];
      this.selectedIndicator = [];
      this.selectedDateFrom = moment().format('YYYY-MM');
      this.selectedDateTo = moment().format('YYYY-MM');
    },
    loadReportData(data) {
      if (data) {
        this.selectedObjects = data.objects ?? [];
        this.selectedIndicator = data.indicators ?? [];
        this.selectedDateFrom = data.date_from ?? moment().format('YYYY-MM');
        this.selectedDateTo = data.date_to ?? moment().format('YYYY-MM');
      } else {
        this.drop();
      }
    },
    selectObject() {
      if (this.selectedObjects[this.selectedObjects.length - 1] === this.allField) {
        this.selectedObjects = [this.allField];
      } else {
        if (this.selectedObjects.length > 1) {
          this.selectedObjects = this.selectedObjects.filter(item => item !== this.allField);
        }
      }
    },
  },
}
</script>
